<template>
  <div class="d-flex gap-4 flex-wrap">
    <div>
      <div class="tc-attribution-label mb-2" style="font-weight:var(--w-medium)">Variant A — reasoning (default ? click)</div>
      <div class="tc-cell-popover" style="position:static;width:340px;box-shadow:var(--shadow-8)">
        <DfReasoningContent context-label="2024-ACME-001 · Support · Tue Apr 17 · 1.5h" />
      </div>
    </div>

    <div>
      <div class="tc-attribution-label mb-2" style="font-weight:var(--w-medium)">Variant B — picker (after Change project)</div>
      <div class="tc-cell-popover" style="position:static;width:340px;box-shadow:var(--shadow-8)">
        <DfPopoverContent context-label="2024-ACME-001 · Support · Tue Apr 17 · 1.5h" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import DfPopoverContent from './DfPopoverContent.vue';
import DfReasoningContent from './DfReasoningContent.vue';
</script>
